import {
  GET_SETTINGS_EXITO,
  GET_SETTINGS,
  RESET_SETTINGS_BY_TYPE
} from '../types/settingsActionsTypes'
import { SettingsData } from '../../interfaces/Settings/settings'

export type SettingsAction = SettingsActionSuccess | SettingsActionAsync | SettingsActionReset

// Esto va a REDUX
export interface SettingsActionSuccess {
  type: typeof GET_SETTINGS_EXITO
  settings: SettingsData[]
  error: string | undefined
  typeSettingId: number
}

export const getSettingsAction = (
  settings: SettingsData[],
  error?: string,
  typeSettingId: number = 0
): SettingsActionSuccess => {
  return {
    type: GET_SETTINGS_EXITO,
    settings,
    error,
    typeSettingId
  }
}

// Esto va a SAGA
export interface SettingsActionAsync {
  type: typeof GET_SETTINGS
  typeSettingId: number
  productOriginId?: number | null
}

export const getSettingsActionAsync = (
  typeSettingId: number,
  productOriginId?: number | null
): SettingsActionAsync => {
  return {
    type: GET_SETTINGS,
    typeSettingId,
    productOriginId
  }
}

export interface SettingsActionReset {
  type: typeof RESET_SETTINGS_BY_TYPE
  typeSettingId: number
}

export const resetSettingsAction = (typeSettingId: number): SettingsActionReset => {
  return {
    type: RESET_SETTINGS_BY_TYPE,
    typeSettingId
  }
}
